"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeFpid = void 0;
const getFpid_1 = require("./getFpid");
async function initializeFpid(shouldInitialize, retry = 100) {
    if (shouldInitialize && !shouldInitialize()) {
        if (document.readyState !== 'complete') {
            setTimeout(() => initializeFpid(shouldInitialize, retry), retry);
        }
        return;
    }
    return await (0, getFpid_1.getFpid)();
}
exports.initializeFpid = initializeFpid;
